export const AVAILABLE_LANGUAGES = ['en', 'de', 'ru'];
